import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Box,
  Card, CardContent, makeStyles, Typography,
} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Notes from '@material-ui/icons/Notes';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  card: {
    background: theme.palette.background.card,
    color: theme.palette.text.default,
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(1, 0),
    borderRadius: '10px',
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.background.hoverCard,
    },
  },
  cardSelected: {
    background: '#1A3758',
    color: theme.palette.text.default,
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(1, 0),
    borderRadius: '10px',
    border: '1px solid #FCD050',
  },
  cardContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  accordionTitle: {
    fontFamily: 'Raleway',
  },
  cardOpen: {
    background: 'transparent',
    color: theme.palette.text.default,
    padding: theme.spacing(0, 3),
  },
  cardOpenItemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: theme.spacing(0, 0, 1, 0),
    color: theme.palette.background.card,
  },
  cardOpenListItem: {
    background: theme.palette.background.card,
    width: 20,
    height: 20,
    borderRadius: '50%',
    margin: theme.spacing(0, 3, 1, 0),
  },
  cardOpenListItemText: {
    color: theme.palette.text.default,
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
  cardOpenListItemTextSelected: {
    color: theme.palette.background.info,
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
  cardOpenListItemLink: {
    textDecoration: 'none',
  },
  iconContains: {
    margin: theme.spacing(0, 2, 0, 0),
  },
}));
function SummaryLessons({ list }) {
  const classes = useStyles();
  const location = useLocation();
  const {
    lessonId, topic, course, nameCourse, completedLesson, idUser, idTopicUser,
    practicalId, quizzId, finalProjectUserId, practicalStatus, quizzStatus, title,
  } = location.state;

  const [open, setOpen] = useState(false);
  const [content, setContent] = useState([]);

  const openCard = () => {
    setOpen(!open);
    setContent(list.contains);
  };

  const printAccordion = () => (
    <div>
      <Box>
        <Card
          className={list.idLesson === lessonId ? classes.cardSelected : classes.card}
        >
          <CardContent onClick={openCard}>
            <Box className={classes.cardContent}>
              <Typography className={classes.accordionTitle}>{list.name}</Typography>
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>
          </CardContent>
        </Card>
        {open === false ? null
          : (
            <Card className={classes.cardOpen} elevation={0}>
              {content.map((i) => {
                if (i.type === 'pdf' || i.type === 'text') {
                  return (
                    <Link
                      className={classes.cardOpenListItemLink}
                      to="/lesson"
                      state={{
                        lessonId: list.idLesson,
                        type: i.type,
                        topic,
                        course,
                        name: list.name,
                        nameCourse,
                        idLessonUser: list.id,
                        completedLesson,
                        idUser,
                        idTopicUser,
                        practicalId,
                        quizzId,
                        finalProjectUserId,
                        practicalStatus,
                        quizzStatus,
                        title: i.title,
                      }}
                      key={i.title}
                    >
                      <Box className={classes.cardOpenItemContent}>
                        <Notes className={classes.iconContains} />
                        <Typography
                          className={
                            i.title === title
                              ? classes.cardOpenListItemTextSelected
                              : classes.cardOpenListItemText
                          }
                        >
                          {' '}
                          {i.title}
                        </Typography>
                      </Box>
                    </Link>
                  );
                }
                if (i.type === 'video') {
                  return (
                    <Link
                      key={i.type}
                      className={classes.cardOpenListItemLink}
                      to="/lesson"
                      state={{
                        lessonId: list.idLesson,
                        type: i.type,
                        topic,
                        course,
                        name: list.name,
                        nameCourse,
                        idLessonUser: list.id,
                        completedLesson,
                        idUser,
                        idTopicUser,
                        practicalId,
                        quizzId,
                        finalProjectUserId,
                        practicalStatus,
                        quizzStatus,
                        title: i.title,
                      }}
                    >
                      <Box className={classes.cardOpenItemContent}>
                        <VideoLibraryIcon className={classes.iconContains} />
                        <Typography
                          className={i.title === title ? classes.cardOpenListItemTextSelected
                            : classes.cardOpenListItemText}
                        >
                          {' '}
                          {i.title}
                        </Typography>
                      </Box>
                    </Link>
                  );
                }
                return i.type;
              })}
            </Card>
          )}
      </Box>
    </div>
  );
  return (
    <div>
      {printAccordion()}
    </div>
  );
}

export default SummaryLessons;

SummaryLessons.propTypes = {
  list: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ])).isRequired,
};
